import React from 'react';
import cn from 'classnames';
import { Party } from 'src/types/data-types';

import css from './Card.module.scss';

interface Props {
  className?: string;
  state?: 'disabled' | 'blue' | 'red' | 'default';
  isClickable?: boolean; //
  data: Party;
  onSelect?: (id: string) => void;
  size?: 'm' | 's';
}

export const Card: React.FC<Props> = ({ className, state = 'default', data, size, onSelect, isClickable = true }) => {
  const onCardClick = () => {
    if (onSelect) {
      onSelect(data.id);
    }
  };

  return (
    <div
      className={cn(css.card, className, css[state], isClickable && css.isClickable, size && css[`size-${size}`])}
      onClick={onCardClick}
    >
      <div className={css.imageWrap}>
        <div className={css.image}>
          <img src={data.leaderImageUrl} alt={data.leaderName} />
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="111"
          height="27"
          viewBox="0 0 111 27"
          fill="none"
          className={css.shape}
        >
          <path
            d="M111 27C111 27 98.8289 27 55.5 27C12.1711 27 0 27 0 27V2.87387C0 2.87387 12.1711 27 55.5 27C98.8289 27 111 0 111 0V27Z"
            fill="white"
          />
        </svg>
      </div>
      <div className={css.info}>
        <h5 className={css.party}>{data.name}</h5>
        <h6 className={css.partyLeader}>{data.leaderName}</h6>
      </div>
    </div>
  );
};
